import { removeWmsLayer } from './remove_wms_layer.function';
import mapboxgl from 'mapbox-gl';
import { geoServerLinks } from './get_geoServer_links.function';

mapboxgl.accessToken = process.env.REACT_APP_PUBLIC_MAP_BOX_GL_ACCESS_TOKEN;

export const addWmsLayer = async (
  map,
  currentKmzNetwork,
  currentPopup,
  stepRef,
  showBackdrop,
  hideBackdrop,
  controller
) => {
  showBackdrop();
  try {
    if (map.current.getSource('linksLayers')) {
      removeWmsLayer(map);
    }
    if (!map.current.getSource('linksLayers')) {
      const data = await geoServerLinks(currentKmzNetwork, controller.signal);

      if (!data) {
        console.log('request aborted by user');
        return;
      }

      map.current.addSource('linksLayers', {
        type: 'geojson',
        data: data,
      });

      map.current.addLayer({
        id: 'linksLayers',
        type: 'line',
        source: 'linksLayers',
        paint: {
          'line-color': 'green',
          'line-opacity': 0.4,
          'line-width': 3,
        },
      });

      map.current.addLayer({
        id: 'linksLayers-dashed',
        type: 'line',
        source: 'linksLayers',
        paint: {
          'line-color': 'green',
          'line-width': 3,
          'line-dasharray': [0, 4, 3],
        },
      });
      const dashArraySequence = [
        [0, 4, 3],
        [0.5, 4, 2.5],
        [1, 4, 2],
        [1.5, 4, 1.5],
        [2, 4, 1],
        [2.5, 4, 0.5],
        [3, 4, 0],
        [0, 0.5, 3, 3.5],
        [0, 1, 3, 3],
        [0, 1.5, 3, 2.5],
        [0, 2, 3, 2],
        [0, 2.5, 3, 1.5],
        [0, 3, 3, 1],
        [0, 3.5, 3, 0.5],
      ];

      const animateDashArray = (timestamp) => {
        const newStep = parseInt((timestamp / 120) % dashArraySequence.length);

        map.current.setPaintProperty(
          'linksLayers-dashed',
          'line-dasharray',
          dashArraySequence[stepRef.current]
        );
        stepRef.current = newStep;

        requestAnimationFrame(animateDashArray);
      };

      // animateDashArray(0);
      if (map?.current.getLayer('linksLayers-dashed')) {
        animateDashArray(0);
      }

      map.current.on('mouseenter', 'linksLayers', () => {
        map.current.getCanvasContainer().style.cursor = 'pointer';
      });
      map.current.on('mouseenter', 'linksLayers', (e) => {
        const feature = map.current.queryRenderedFeatures(e.point, {
          layers: ['linksLayers'],
        })[0];
        if (feature) {
          const properties = feature?.properties;
          const lng = e.lngLat;
          const tooltipHtml = `
              <div class="tooltip-container">
                <div class="title_container_tooltip">
                  <div class="title_text_container_tooltip">
                    <h3 class="tooltip-heading">${properties?.layer_name || '--'}</h3>
                    <p class="tooltip-item">Length (km): ${properties?.length?.toFixed(2) || '--'}</p>
                    <p class="popup-item"><strong>Commission Date:</strong> ${
                      properties?.commissioned_at
                        ? new Date(properties.commissioned_at).toLocaleDateString('en-GB')
                        : '--'
                    }</p>
                  </div>               
                </div>
              </div>
            `;

          // Create a tooltip or popup with the feature details
          currentPopup = new mapboxgl.Popup({ closeButton: false })
            .setLngLat(lng) // Create a valid LngLatLike object
            .setHTML(tooltipHtml)
            .addTo(map.current);
        }
      });

      map.current.on('mouseleave', 'linksLayers', () => {
        if (currentPopup) {
          currentPopup.remove();
          currentPopup = null;
        }
      });

      map.current.on('mouseleave', 'linksLayers', () => {
        map.current.getCanvasContainer().style.cursor = '';
      });
    }
  } catch (error) {
    console.error('Error adding WFS layer:', error);
  }
  hideBackdrop();
};
